// extracted by mini-css-extract-plugin
export default {"container":"SMQbq1ic","info":"xSdAlPXD"};